import React, {useEffect, useState} from "react";
import {SurveyProductsSchema, useSurveyProducts} from "../../commons";
import {useIntl} from "react-intl";
import {EditableQuotationDraftProps} from "../types";
import QuotationDraft from "./quotation-draft";

export const NewQuotationDraft = ({
  worksite,
  surveys,
  agent,
  enterprise,
  resale,
  onExit,
  enterpriseToBeInvited,
  kColorPriceChoose
}: EditableQuotationDraftProps) => {
  // state
  const [data, setData] = useState<SurveyProductsSchema>();

  // hooks
  const { fetch, loading } = useSurveyProducts();

  // context
  const intl = useIntl();

  useEffect(() => {
    fetch(surveys, "WEB", kColorPriceChoose).then((res) => {
      setData(res);
    });
  }, []);

  return (
    <QuotationDraft
      data={undefined}
      editable={true}
      worksite={worksite}
      agent={agent}
      enterprise={enterprise}
      resale={resale}
      loading={loading}
      surveys={surveys}
      products={data}
      setProducts={setData}
      onHistoryBackClick={() => {
        const msg = intl.formatMessage({
          id: "quotation_discard_changes_confirmation",
        });
        if (window.confirm(msg)) onExit();
      }}
      fullScreen
      enterpriseToBeInvited={enterpriseToBeInvited}
      kColorPriceChoose={kColorPriceChoose}
    />
  );
};